import { useRef } from 'react';
import { usePrintedAST, makeHtmlNodeToJsxPrinter, textNodeToJsxPrinter, generateJsxKey } from '@utils/ast';
import { useKatex } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { PlaceItemsInTextDropzone } from './input.dropzone.js';
import { linebreak, wrapper, label, container } from './molecule.dropzones.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function DropzoneContainer(props) {
  const context = useTaskContext();
  const pageContext = usePageContext();
  const ref = useRef(null);
  useKatex(ref);
  const dropzoneCount = props.content.filter(it => it.nodeType === "in-text-dropzone-input").length;
  const content = usePrintedAST(props.content, {
    text: textNodeToJsxPrinter,
    html: makeHtmlNodeToJsxPrinter({
      skipLeadingBRs: true,
      skipTrailingBRs: true,
      handleTag(tag, data, context) {
        switch (tag) {
          case "br":
            return /*#__PURE__*/jsx("span", {
              className: linebreak,
              children: " "
            }, generateJsxKey(context));
        }
      }
    }),
    "in-text-dropzone-input": (node, context) => /*#__PURE__*/jsx(PlaceItemsInTextDropzone, {
      draggable: props.draggable,
      draggedItemId: props.draggedItemId,
      dropzone: node,
      taskEntryKey: props.taskEntryKey,
      tiles: props.tiles,
      facitType: props.facitType
    }, generateJsxKey(context))
  });
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: wrapper,
    "data-context": context,
    "data-page-context": pageContext,
    children: [/*#__PURE__*/jsxs("span", {
      className: label,
      children: [dropzoneCount, " dropzone", dropzoneCount !== 1 ? "r" : ""]
    }), /*#__PURE__*/jsx("div", {
      className: container,
      children: /*#__PURE__*/jsx("div", {
        children: content
      })
    })]
  });
}

export { DropzoneContainer };
//# sourceMappingURL=molecule.dropzones.js.map
